module.exports = __webpack_public_path__ + "static/media/image-4.9412b29e.webp";